import React from 'react';
import styled from 'styled-components';
import { Button, Card, Thumbnail, Text, Title } from '@brokerbay/elements-web';
import { Button as ButtonV2 } from '@bb/elements-web-rebranding';
import type { ListingConfigData } from 'components/ShowingSettingsModal';
import { featureEnabled, formatCurrency } from 'utils';

type Listing = ListingConfigData['listings'][number];

interface ListingComponentProps {
  listings: Listing[];
  onClick: (index?: number) => void;
}

const ActionItemMobile: React.FC<ListingComponentProps> = ({
  listings,
  onClick,
}) => (
  <StyledCardContainer>
    {listings.map(
      (
        {
          line1,
          line2,
          city,
          province,
          postal_code,
          list_price,
          id,
          thumbnail,
        },
        index,
      ) => (
        <Card key={id} dataCy={`action-item-${id}`}>
          <StyledItem>
            <Thumbnail
              src={thumbnail}
              size="small"
              dataCy="action-item-image"
              square
            />
            <StyledContainer>
              <Title
                level={5}
                dataCy={`action-item-address-${id}`}
                style={{ margin: 0 }}
              >
                {line1} {line2}
              </Title>
              <Title
                level={5}
                dataCy={`action-item-address-2-${id}`}
                style={{ margin: 0 }}
              >
                {city}, {province} {postal_code}
              </Title>
              <Text size="large">
                {formatCurrency(list_price, { minimumFractionDigits: 2 })}
              </Text>
            </StyledContainer>
            {featureEnabled('supraRebrandingFeature', 1) ? (
              <ButtonV2
                onClick={() => onClick(index)}
                type="primary"
                dataCy="add-access-V2"
              >
                Add access instructions
              </ButtonV2>
            ) : (
              <Button
                onClick={() => onClick(index)}
                type="primary"
                dataCy="add-access-button"
              >
                Add access instructions
              </Button>
            )}
          </StyledItem>
        </Card>
      ),
    )}
  </StyledCardContainer>
);

const StyledCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const StyledItem = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 16px;
  > button {
    grid-column-end: span 2;
  }
`;

const StyledContainer = styled.div``;

export default ActionItemMobile;
